<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <CourtForm
      :form="form"
      @submit="submit"
      :segment-list="segment"
      @previous-page="previousPage"
      text-button="SALVAR"
    />
    <ModalCancelCourt
      @close="closeModalCancel"
      v-model="modalCancelCourt"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import CourtForm from "../components/CourtForm";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { mapActions, mapState } from "vuex";
import ModalCancelCourt from "../../insurance_company/components/ModalCancelInsurance";
import { formatCode } from "@/utils/formats.js";
import FormMixin from "@/mixins/FormMixin";
import _ from "lodash";
export default {
  beforeRouteLeave(to, from, next) {
    this.modalCancelCourt = true;
    this.nextRoute = to;
    if (this.cancel || this.formIsPristineCommon(this.form, this.cloneForm))
      next();
  },
  data: () => ({
    form: {},
    breadcrumb: [
      {
        text: "Editar Tribunal",
        to: "list region court"
      }
    ],
    modalCancelCourt: false,
    nextRoute: null,
    cancel: false,
    formatCode,
    cloneForm: null
  }),
  components: {
    CourtForm,
    ModalCancelCourt
  },
  mixins: [CommonPayload, LoadingRequest, FormMixin],
  created() {
    this.fetchCourt();
  },
  computed: {
    ...mapState("court", ["currentCourt", "segment"])
  },
  methods: {
    ...mapActions("court", [
      "requestEditCourt",
      "requestCurrentCourt",
      "requestSegment"
    ]),
    ...mapActions(["showAlertNotification"]),
    async fetchCourt() {
      const response = await this.withLoading(
        Promise.all([
          this.requestCurrentCourt(this.$route.params.tribunal),
          this.requestSegment()
        ])
      );
      this.form = response[0];
      this.form.codigo = this.formatCode(this.form.codigo, 2);
      this.cloneForm = _.cloneDeep(this.form);
    },
    submit(form) {
      this.withLoading(
        this.requestEditCourt(this.payloadEditCourt(form)).then(() => {
          this.cancel = true;
          this.showAlertNotification({
            message: "Tribunal editado com sucesso.",
            type: "success"
          });
          this.previousPage();
        })
      );
    },
    previousPage() {
      this.$router.push({
        name: "list region court",
        params: { tribunal: this.$route.params.tribunal }
      });
    },
    payloadEditCourt(form) {
      return {
        id: this.$route.params.tribunal,
        payload: form
      };
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancelCourt = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    }
  }
};
</script>
